import { TextField, Typography } from '@mui/material';
import { useTheme } from '@mui/material';
import { DatabaseTable } from '../../../../shared/components/ui/DatabaseTable';
import type { User } from '../../context/UserContext';

interface UserTableProps {
  users: User[];
  isLoading: boolean;
  onView: (user: User) => void;
  page: number;
  limit: number;
  total: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (limit: number) => void;
}

export function UserTable({ users, isLoading, onView, page, limit, total, onPageChange, onPageSizeChange }: UserTableProps) {
  const theme = useTheme();

  const columns = [

    { field: 'name', headerName: 'Nome', flex: 1 },
    {
      field: 'email',
      headerName: 'E-mail',
      flex: 1,
      renderCell: (params: any) => (
        <Typography
          sx={{
            fontFamily: 'monospace',
            fontSize: 12,
            backgroundColor: '#F3F4F6',
            color: '#111827',
            px: 1,
            py: 0.5,
            borderRadius: 1
          }}
        >
          {params.value}
        </Typography>
      )
    },
    {
      field: 'phone',
      headerName: 'Telefone',
      width: 140,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {params.value || '-'}
        </Typography>
      )
    },
    {
      field: 'cpf_or_rg',
      headerName: 'CPF/RG',
      width: 140,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {params.value || '-'}
        </Typography>
      )
    },
    {
      field: 'birth_date',
      headerName: 'Nascimento',
      width: 140,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {params.value ? new Date(params.value).toLocaleDateString() : '-'}
        </Typography>
      )
    },
    {
      field: 'role',
      headerName: 'Perfil',
      width: 140,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {params.row.role || '-'}
        </Typography>
      )
    },

  ];

  return (
    <DatabaseTable
      filterFields={
        <>
          <TextField label="Nome" value="" onChange={() => { }} />

        </>
      }
      onFilter={() => { }}
      onClearFilter={() => { }}
      defaultFilterOpen={false}
      pageSizeOptions={[5, 15, 25, 50, 100]}
      rows={users as any}
      columns={columns}
      loading={isLoading}
      onView={(row: any) => onView(row as User)}
      hideDelete
      hideEdit
      paginationMode="server"
      page={page}
      pageSize={limit}
      rowCount={total}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
    />
  );
}